import React from 'react'
import clsx from 'clsx'
import type {FunctionComponent, HTMLAttributes, SyntheticEvent} from 'react'
import {CLICK_ID_PLACEHOLDER} from '~/utils/affiliation'
import type {AffiliateLink, ProductVariation} from '~/types'

interface VariationsProps extends HTMLAttributes<HTMLDivElement> {
  variations?: ProductVariation[]
  slug: string
  handleCardClick: (
    _e: SyntheticEvent,
    index: number,
    affiliateLink: AffiliateLink,
    affiliateLinkWithClickId: string,
    itemName: string,
    redirectUrl: string,
    elementName: string,
    elementPlace: string,
  ) => void
  shouldForceTrackAnalytics: boolean
  trackSearchParams: string
  clickId: string
}

const Variations: FunctionComponent<VariationsProps> = ({
  variations,
  slug,
  handleCardClick,
  shouldForceTrackAnalytics,
  trackSearchParams,
  clickId,
  ...attributes
}) => {
  return variations && variations.length ? (
    <div
      className={clsx(
        'no-scrollbar mt-7 flex flex-row space-x-2 overflow-x-auto tablet:w-full tablet:justify-start mobile:mt-4',
        attributes.className,
      )}
    >
      {variations?.map(({name, image, affiliateLink: variantAffiliateLink}, i) => {
        const affiliateLinkWithClickId = variantAffiliateLink?.url?.replaceAll(CLICK_ID_PLACEHOLDER, clickId)
        const redirectUrl = shouldForceTrackAnalytics
          ? `/redirect-analytics?affiliateLink=${encodeURIComponent(affiliateLinkWithClickId)}&${trackSearchParams}`
          : affiliateLinkWithClickId

        return (
          <div
            key={`${name}-${i}`}
            className={clsx(
              i === 0 ? 'border-[#0284C7]' : 'border-[#E2E8F0]',
              'relative flex h-[69px] w-24 min-w-24 flex-col items-center justify-center gap-2 rounded-xl border-1 border-[#E2E8F0] p-2 tablet:h-fit',
            )}
          >
            <a
              href={redirectUrl}
              onClick={(e) =>
                handleCardClick(
                  e,
                  i,
                  variantAffiliateLink,
                  affiliateLinkWithClickId,
                  name,
                  redirectUrl,
                  'css-product-variations',
                  `${i + 1} of ${variations.length}`,
                )
              }
              aria-label={`view ${name}`}
              target="_blank"
              rel="sponsored noreferrer"
              className="absolute inset-0"
            />
            {image ? (
              <img src={image} alt={`${name} option`} className="size-[30px] rounded object-scale-down tablet:hidden" />
            ) : (
              <div className="size-[30px] rounded bg-[#E2E8F0] tablet:hidden" />
            )}
            <span className="line-clamp-1 w-full text-center text-xs font-light text-[#71717A]">{name}</span>
          </div>
        )
      })}
    </div>
  ) : null
}

export default Variations
